import React from 'react';
import { graphql, HeadProps, PageProps } from 'gatsby';
import { Kfh_AreaType, Kfh_PropertyTypeInterface } from '../../types/graphqlTypes';
import LocationDetail from '../../components/locations/LocationDetail';
import { SEO } from '../../components/Seo';

interface AreaPageProps {
  area: Kfh_AreaType;
  rentalProperties: {
    edges: Kfh_PropertyTypeInterface[]
  };
  resaleProperties: {
    edges: Kfh_PropertyTypeInterface[]
  };
}

const AreaPage = ({ data }: PageProps<AreaPageProps>) => (
  <>
    <LocationDetail
      location={data.area}
      rentalProperties={data.rentalProperties.edges}
      resaleProperties={data.resaleProperties.edges}
    />
  </>
);

export default AreaPage;

export const Head = ({ data }: HeadProps<AreaPageProps>) => {
  const seo = data.area.seoPages.find((seoPage) => seoPage.remoteTypeName === 'KfhSeoAreaGuideType');
  return <SEO data={seo} />;
};

export const pageQuery = graphql`
  query AreaPagePageQuery($id: String!) {
    resaleProperties: allKfhResidentialResalePropertyType(
      limit: 6
      filter: { area: { id: { eq: $id } }, available: { eq: true } }
      sort: { createdDate: DESC }
    ) {
      edges {
        node {
          ...PropertyListingProperties
        }
      }
    }
    rentalProperties: allKfhResidentialRentalPropertyType(
      limit: 6
      filter: { area: { id: { eq: $id } }, available: { eq: true }, sellingState: { ne: "Under offer" } }
      sort: { createdDate: DESC }
    ) {
      edges {
        node {
          ...PropertyListingProperties
        }
      }
    }

    area: kfhAreaType(id: { eq: $id }) {
      __typename
      id
      name
      relativeUrl
      artirixMultiSearch
      artirixDisplayName
      guide
      latitude
      longitude
      staticMap {
        ...LocationStaticMap
      }
      coordinates {
        lat: latitude
        lng: longitude
      }
      mediaSet {
        media {
          media {
            ...LocationGalleryImage
          }
        }
      }
      locationSoldData {
        soldData {
          monthlyStatistics {
            average
          }
        }
      }
      propertiesForSale {
        properties {
          totalCount
        }
      }
      propertiesForRent {
        properties {
          totalCount
        }
      }

      relatedBoroughs {
        edges {
          node {
            id
            name
            relativeUrl
          }
        }
      }
      relatedAreas {
        edges {
          node {
            id
            relativeUrl
            name
          }
        }
      }
      branch {
        name
        relativeUrl
        businessProfile {
          lettingsContactDetails {
            email
            telephone
          }
          salesContactDetails {
            email
            telephone
          }
        }
      }
      region {
        name
        relativeUrl
      }
      seoPages {
        ... on KFH_KfhSeoAreaGuideType {
          id
          h1
          htmlDescription
          title
          slug
          remoteTypeName
          priority
          onSiteMap
          noIndex
          metaKeywords
          noFollow
          metaDescription
          metaCopyright
          metaAuthor
        }
      }
    }
  }
`;
